<script>
// Import general mixin for shared functionality.
import mixin from './../mixin';

export default {
	mixins: [mixin],
	props: ['imageSets', 'imageClass'],
	methods: {
		// Simple media query transformer.
		toMediaQuery(mediaString) {
			if (!mediaString) return '';
			return mediaString.split('"')[1];
		},
	},
	// Retrieve width and height from first image in set for refucing cumulative layout shift.
	// Ideally, these values come from the API in the future.
	computed: {
		firstWidth() {
			return this.imageSets[0].images[0].displayWidth;
		},
		firstHeight() {
			return this.imageSets[0].images[0].defaultCropUrlWebp
				.split('height=')[1]
				.split('&')[0];
		},
	},
};
</script>

<template>
	<picture :class="imageClass">
		<template
			v-for="(format, index) in reverse(imageSets[0].images)"
			:key="index">
			<source
				type="image/webp"
				:srcset="format.webPUrl"
				:sizes="format.displayWidth + 'px'"
				:media="toMediaQuery(format.mediaQuery)" />
		</template>
		<img
			:src="imageSets[0].images[0].defaultCropUrlJpeg"
			:alt="imageSets[0].alias"
			:width="firstWidth"
			:height="firstHeight"
			loading="lazy"
			onerror="this.onerror=null; this.style.backgroundColor='#cccccc'" />
	</picture>
</template>
